<template>
  <div class="faqs">
    <template v-for="q in page.faqs">
      <h4 :key="'a' + q._id" class="accordion-toggle">
        {{q.question}}
        <i class="fa fa-chevron-down"></i>
        <i class="fa fa-chevron-up"></i>
      </h4>
      <div :key="'q' + q._id" class="accordion-content" v-html="q.answer"></div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "Faqs",
  computed: {
    ...mapState(["page"])
  }
}
</script>

<style scoped>
.accordion-toggle {
  cursor: pointer;
  color: #f79227;
  margin-top: 1rem;
  font-size: 2rem;
  background: #f5f5f5;
  padding: 0.5rem 1.5rem;
  padding-right: 4rem;
  font-weight: normal;
  position: relative;
  line-height: 1.2;
}
.accordion-toggle i {
  position: absolute;
  right: 1rem;
  color: rgba(67, 79, 80, 0.181);
  top: 50%;
  transform: translateY(-50%);
}
.accordion-toggle:hover {
  background: #f0f0f0;
}
.accordion-toggle:hover i {
  color: rgba(67, 79, 80, 0.381);
}
.accordion-content {
  display: none;
  padding: 1rem 1.5rem;
  padding-bottom: 0;
  font-size: 1.5rem;
}
.accordion-content.default {
  display: block;
}
.fa-chevron-up {
  display: none;
}
.open .fa-chevron-up {
  display: block;
}
.open .fa-chevron-down {
  display: none;
}
</style>
